<template>
  <div class="sidebar-logo-container"
       :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link class="sidebar-logo-link" to="/">
        <img :src="require('../../../assets/the-missing-link-blue.svg')"
             class="sidebar-logo"
             alt="Harness">
        <img v-if="!collapse" class="sidebar-title" :src="require('../../../assets/harness-text-no-logo.svg')"
            alt="Harness">
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'Harness',
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 69px;
  line-height: 69px;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
  text-align: left;
  padding-left: 14px;
  overflow: hidden;

  .sidebar-logo-link {
    height: 100%;
    width: 100%;

    .sidebar-logo {
      width: 25px;
      height: 25px;
      vertical-align: middle;
      margin-left: 5px;
      display: inline-block;
    }

    .sidebar-title {
      width: 100px;
      height: 25px;
      margin-left: 12px;
      vertical-align: middle;
      display: inline-block;
    }
  }

}
</style>
